export { default } from './SwipeableDrawer';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/SwipeableDrawer/index.js
// module id = 813
// module chunks = 121